import * as React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'translations';
import { getRequestErrorMessage } from 'util/helpers';
import type { RequestEntry } from '@wappsto/redux';

interface ShowErrorProps {
  request?: Partial<RequestEntry>;
  description?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  skipCodes?: number[];
}

const ShowError = React.memo(({ request, description, className = '', style = {}, skipCodes = [] }: ShowErrorProps) => {
  const { tC } = useTranslation();
  if (
    request &&
    request.status === 'error' &&
    (!request.json || skipCodes.indexOf(request.json.code) === -1)
  ) {
    const { message } = getRequestErrorMessage(request, tC);
    return (
      <Alert
        showIcon
        type="error"
        message={message}
        className={className}
        description={description}
        style={style}
      />
    );
  }
  return null;
});

ShowError.displayName = 'ShowError';

export default ShowError;
